// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"_3VpQw","menuItem":"_3VpQw"};